<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
    <path
      d="M11.6653 0.666117V3.33254H2.88611L5.27256 0.939426L4.33264 -0.000488281L0.333008 3.99915L4.33264 7.99878L5.27256 7.05887L2.88611 4.66575H12.9985V0.666117H11.6653Z"
      fill="currentColor"
    />
  </svg>
</template>
